import * as _ from 'lodash'
import * as moment from 'moment'
// Libraries
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Subject }    from 'rxjs/Subject';
// Services
import { ApiService, SettingService } from '../../common/modules/core/services';
//Models
import {Payment, BookingList, BookingFilter,ClassList, ClassFilter, BookingDetail, BookingPayment, MakeTransaction, ListStudent, DiscoundConfig } from '../models'

@Injectable()
export class BookingHolidayService {
    // Api Domain Url
    private apiUrl = '';
    // For Countdown function
    private isStartCountdown = new Subject<boolean>();
    private countdown: string
    // Observable string streams
    countdownAnnounced$ = this.isStartCountdown.asObservable();

    // Url List for Booking Site 
    private children: string = '/parent';
    private course: string = '/course';
    private class: string = '/class';
    private week: string = '/week';
    private booking: string = '/booking';
    private questionnaire: string = '/questionnaire';
    private excursion: string = '/excursion';
    private paymentUrl ='/booking/payment/do';
    private studentListUrl = '/students';
    private contents = '/contents';
    private configuration = 'configuration';
    
    constructor(
        private apiService: ApiService,
        private settingService: SettingService
    ) {
        // Get API service domain for communate.
        this.apiUrl = this.settingService.getSetting('api_service_domain') + '/hol';
    }

    // Get contents
    getContents(contents:string) {
        let requestUrl = this.settingService.getSetting('api_service_domain') + this.contents + '?' + 'key=' + contents;
        return this.apiService.get<any>(requestUrl);
    }

    payment(payment: Payment): Observable<any> {
        const requestUrl = this.apiUrl + this.paymentUrl + '?amount=' + payment.amount +'&zone=' + payment.zone + '&booking_id='+ payment.booking_id + '&currency=VND';

        return this.apiService.get<Payment>(requestUrl);
    }

    // Activate countdown function on AppComponent
    startCountdown(start: boolean) {
        return this.isStartCountdown.next(start);
    }

    // Get all children of logged parent
    getChildren(): Observable<any> {
        let requestUrl = this.apiUrl + this.children;
        return this.apiService.get<any>(requestUrl);
    }


    // Get all children of logged parent by name
    getStudents(filter: any): Observable<ListStudent> {
        let requestUrl = this.apiUrl + this.studentListUrl + '?';
        let i = 0;
        _.forEach(filter, (val, key) => {
            if(val !== ''){
                requestUrl = !i ? requestUrl + key + '=' + val : requestUrl + '&' + key + '=' + val;
                i++
            }
        });

        return this.apiService.get<ListStudent>(requestUrl);

    }

    // Get booking
    getBooking(filter: any): Observable<any> {
        let requestUrl = this.apiUrl + this.booking + '?';
        let i = 0;
        _.forEach(filter, (val, key) => {
            if(val !== ''){
                requestUrl = !i ? requestUrl + key + '=' + val : requestUrl + '&' + key + '=' + val;
                i++
            }
        })
        return this.apiService.get<any>(requestUrl);
    }

    // Get Booking by id
    getBookingById(aisId:any) {
        let requestUrl = this.apiUrl + this.booking + '?' + 'student=' + aisId +'&page=1';
        return this.apiService.get<any>(requestUrl);
    }

    // Retrieve all clasess base on child's dob
    getClasses(filter: any): Observable<any> {
        let requestUrl = this.apiUrl + this.class + '?';
        let i = 0;

        _.forEach(filter, (val, key) => {
            if(val !== ''){
                requestUrl = !i ? requestUrl + key + '=' + val : requestUrl + '&' + key + '=' + val;
                i++
            }
        })

        return this.apiService.get<any>(requestUrl);
    }

    // Get all holiday weeks
    getWeeks(): Observable<any> {
        let requestUrl = this.apiUrl + this.week;
        return this.apiService.get<any>(requestUrl);
    }

    // Get all holiday excursion
    getExcursions(): Observable<any> {
        let requestUrl = this.apiUrl + this.excursion;
        return this.apiService.get<any>(requestUrl);
    }

    // Get all holiday questionnaire
    getQuestionnaire(status: boolean): Observable<any> {
        let requestUrl = this.apiUrl + this.questionnaire + '?' + `status=${status}` ; 
        return this.apiService.get<any>(requestUrl);
    }
    

    // ────────────────────────────────────────────────────────────────────────────────
    // Post Booking Holiday Class
    postBooking(query: any): Observable<any> {
        const requestUrl = this.apiUrl + this.booking;
        const body = JSON.stringify(query);
        return this.apiService.post(requestUrl, body);
    }

    // ────────────────────────────────────────────────────────────────────────────────
    // Update Booking Holiday Class
    updateBooking(query: any): Observable<any> {
        const requestUrl = this.apiUrl + this.booking;
        const body = JSON.stringify(query);
        return this.apiService.patch(requestUrl, body);
    }

    //get Booking Discount config
    getDiscountConfig(config: string): Observable<any> {
        const requestUrl = `${this.apiUrl}/${this.configuration}/${config}`;
        return this.apiService.get<DiscoundConfig>(requestUrl);
    }
}


// WEBPACK FOOTER //
// ./src/holiday/services/BookingHolidayService.ts